module.exports = __webpack_public_path__ + "media/img/business-background-66b9528d.svg";